export default __webpack_public_path__ + "static/media/SellectedDropDown.27511168.svg";